import {createApp} from 'vue';
import {createPinia} from 'pinia';
import {createI18n} from 'vue-i18n';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import * as Sentry from '@sentry/vue';
import {createGtag} from 'vue-gtag';
import App from './App.vue';
import messages_de from '@/messages/messages_de';
import indexRouter from '@/router/index.router';
import {LOCALE} from '@/utils/common.util';
import {log} from '@/utils/logger';
import {persistContext, useContextStore} from '@/store/context.store';

const REPORT_ERRORS = import.meta.env.PROD;
const TRACK_USAGE = import.meta.env.PROD;
const GA_MEASUREMENT_ID = 'G-GK5YE5KDL2';

function environment() {
	if (window.location.hostname) {
		return window.location.hostname;
	}
	return import.meta.env.MODE;
}

const app = createApp(App);

app.config.errorHandler = (err, instance, info) => {
	log.error(`error: "${err}" in [${info}], Vue: `, instance);
};
app.config.warnHandler = (msg, instance, trace) => {
	log.warn(`warning: "${msg}" in [${trace}], Vue: `, instance);
};

if (REPORT_ERRORS) {
	Sentry.init({
		app,
		dsn: 'https://92501cb01a804d4dbb4b75466a1e4a90@sentry.io/1437712',
		release: `${__APP_NAME__}@${__APP_VERSION__}`,
		environment: environment(),
		attachProps: false,
	});
}

const pinia = createPinia();
app.use(pinia);
persistContext(useContextStore(pinia));

dayjs.locale(LOCALE);
app.use(createI18n({
	legacy: false,
	locale: LOCALE,
	messages: {
		de: messages_de,
	},
}));

app.use(indexRouter);

if (TRACK_USAGE) {
	app.use(createGtag({
		tagId: GA_MEASUREMENT_ID,
		pageTracker: {
			router: indexRouter,
			// the router sets document.title in its own afterEach, which runs before this one
			template: (route) => ({
				page_title: document.title,
				page_path: route.path,
				page_location: window.location.href,
			}),
		},
	}));
}

app.mount('#app');
